import { PLATES } from "../../plate/palettes";
import { labelOf } from "../../data/decomposition";
import LegendGlyph from "./LegendGlyph";

// Parts awaiting a location: listed in the margin, not guessed into the model.
// Each is a real <button>, so it is in the tab order and activates with
// Enter or Space with no extra key handling.
export default function UnplacedBlock({ nodes, onSelect, palette = PLATES.drawing }) {
  const items = (nodes || []).filter((n) => n && n.unknown);
  if (!items.length) return null;
  return (
    <section className="plate-unplaced" aria-labelledby="plate-unplaced-h">
      <h2 className="p-label" id="plate-unplaced-h">UNPLACED</h2>
      <ul>
        {items.map((n) => (
          <li key={n.id}>
            <button type="button" className="u-btn" onClick={() => onSelect && onSelect(n)}>
              <LegendGlyph kind={n.kind} palette={palette} />
              <span className="uname">{labelOf(n)}</span>
              {n.note ? <span className="unote">{n.note}</span> : null}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
